import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from 'react-router-dom'
import { ErroDaApi } from './api/client'
import { ProvedorDeSessao } from './auth/ProvedorDeSessao'
import { router } from './routes/router'
import './index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      /**
       * Repetir só o que pode dar certo na segunda vez.
       *
       * 403, 404 e 422 são respostas definitivas: repetir esconde a mensagem do
       * servidor atrás de três segundos de "carregando" e ainda multiplica a carga
       * quando o erro é sistêmico. O 401 fica de fora porque o interceptor já renova
       * a sessão e refaz a chamada uma vez.
       */
      retry: (tentativas, erro) => {
        if (erro instanceof ErroDaApi && erro.status >= 400 && erro.status < 500) {
          return false
        }
        return tentativas < 1
      },
    },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ProvedorDeSessao>
        <RouterProvider router={router} />
      </ProvedorDeSessao>
    </QueryClientProvider>
  </StrictMode>,
)
